var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPaymentProcessing({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-Submit_Invoice"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Submit_Invoice",
    "data-name": "Submit Invoice",
    clipPath: "url(#clip-Submit_Invoice)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_11733",
    "data-name": "Group 11733",
    transform: "translate(2.771 0.762)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11734",
    "data-name": "Group 11734",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_22145",
    "data-name": "Path 22145",
    d: "M65.288,70.3c0-.076,0-.153,0-.229,0-.03-.009-.041-.038-.048a1.9,1.9,0,0,1-.659-.3.472.472,0,0,1-.217-.368.417.417,0,0,1,.174-.367.438.438,0,0,1,.512-.015,1.44,1.44,0,0,0,.28.164,1.11,1.11,0,0,0,.6.05.924.924,0,0,0,.533-.28.518.518,0,0,0,0-.732.92.92,0,0,0-.627-.294c-.126-.009-.252-.011-.377-.027a1.891,1.891,0,0,1-.643-.206,1.657,1.657,0,0,1-.757-.8,1.145,1.145,0,0,1-.1-.394,1.442,1.442,0,0,1,.623-1.313,1.676,1.676,0,0,1,.666-.312c.028-.006.036-.018.036-.047,0-.154,0-.308,0-.462a.442.442,0,0,1,.648-.4.41.41,0,0,1,.231.342c.012.168.008.337.008.506,0,.036.009.051.046.06a1.646,1.646,0,0,1,.712.348.424.424,0,0,1,.142.451.419.419,0,0,1-.346.317.4.4,0,0,1-.346-.08.982.982,0,0,0-.447-.2,1.249,1.249,0,0,0-.414,0,.918.918,0,0,0-.521.273.529.529,0,0,0,.045.795.953.953,0,0,0,.588.24,4.2,4.2,0,0,1,.462.043,1.784,1.784,0,0,1,.865.4,1.508,1.508,0,0,1,.51.806,1.339,1.339,0,0,1-.191,1.055,1.636,1.636,0,0,1-.758.632c-.1.044-.209.073-.314.107-.024.008-.034.017-.034.044,0,.147,0,.294,0,.441a.444.444,0,0,1-.154.357.4.4,0,0,1-.428.089.427.427,0,0,1-.3-.366,2.631,2.631,0,0,1,0-.287h-.006",
    transform: "translate(-62.181 -62.099)",
    fill: "#0072ce"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22146",
    "data-name": "Path 22146",
    d: "M67.278,351.28c1.024,0,.658,0,1.682,0a.458.458,0,0,1,.473.4.423.423,0,0,1-.173.4.451.451,0,0,1-.291.095c-.075,0-.15,0-.225,0H64.2a.461.461,0,0,1-.371-.163.412.412,0,0,1-.073-.442.425.425,0,0,1,.356-.277.962.962,0,0,1,.128-.007h3.038",
    transform: "translate(-61.949 -341.508)",
    fill: "#0072ce"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22147",
    "data-name": "Path 22147",
    d: "M67.385,415.176c1.027,0-.728,0,.3,0,.269,0,.7.184.735.358a.418.418,0,0,1-.164.435,1.537,1.537,0,0,1-.579.1H64.305a.471.471,0,0,1-.369-.16.437.437,0,0,1,.05-.618.486.486,0,0,1,.327-.111h3.073",
    transform: "translate(-62.055 -403.626)",
    fill: "#0072ce"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22148",
    "data-name": "Path 22148",
    d: "M224.7,287.454c.287,0,.573,0,.86,0a.533.533,0,0,1,.151.018.441.441,0,0,1-.073.863c-.046,0-.092.006-.138.007q-.831,0-1.661,0a.443.443,0,0,1-.078-.882c.038,0,.076-.006.114-.006h.825",
    transform: "translate(-217.149 -279.458)",
    fill: "#0072ce"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22149",
    "data-name": "Path 22149",
    d: "M224.764,223.569c.286,0,.571,0,.857,0a.539.539,0,0,1,.151.018.435.435,0,0,1,.312.352.414.414,0,0,1-.167.421.439.439,0,0,1-.29.1h-1.734a.45.45,0,0,1-.459-.388.422.422,0,0,1,.139-.378.476.476,0,0,1,.343-.122c.283,0,.566,0,.85,0",
    transform: "translate(-217.213 -217.35)",
    fill: "#0072ce"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22150",
    "data-name": "Path 22150",
    d: "M5.772,14.215c-.012-.133-.019-.267-.019-.4a4.445,4.445,0,0,1,.027-.486H.891V.892H6.215V.936q0,1.3,0,2.6a.9.9,0,0,0,.732.893,1.012,1.012,0,0,0,.193.017H9.764V9.764c.127-.011.256-.017.387-.017a4.442,4.442,0,0,1,.5.029c0-1.794,0-3.921,0-5.715a.55.55,0,0,0-.171-.412Q8.76,1.928,7.038.2C7.007.171,6.978.138,6.945.11A.472.472,0,0,0,6.634,0c-.1,0-.194,0-.291,0H.929A.9.9,0,0,0,.215.318.853.853,0,0,0,.03.678,1.025,1.025,0,0,0,.016.791L0,.744v12.75l.02-.074a.9.9,0,0,0,.03.182.87.87,0,0,0,.621.582c.035.01.072.012.108.022l-.05.01ZM7.1,1.525,9.13,3.552H7.1Z",
    transform: "translate(0 0)",
    fill: "#0072ce"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_556",
    "data-name": "Ellipse 556",
    cx: 3.352,
    cy: 3.352,
    rx: 3.352,
    ry: 3.352,
    transform: "translate(5.753 9.773)",
    fill: "none",
    stroke: "#0072ce",
    strokeMiterlimit: 10,
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22152",
    "data-name": "Path 22152",
    d: "M.93,1.775H1c1.042,0,1.148,0,2.19,0a.461.461,0,0,0,.143-.018.279.279,0,0,0-.078-.541c-.028,0-.057,0-.086,0-1.036,0-1.135,0-2.17,0H.929l-.023-.03A.236.236,0,0,0,.97,1.152c.194-.192.388-.383.579-.578A.28.28,0,0,0,1.433.1a.283.283,0,0,0-.294.085Q.73.6.319,1.008c-.092.092-.184.183-.275.275a.279.279,0,0,0,0,.421Q.6,2.259,1.15,2.81a.279.279,0,0,0,.411.011.283.283,0,0,0-.017-.412L.97,1.836C.955,1.82.937,1.807.921,1.793L.93,1.775",
    transform: "translate(10.655 11.549) rotate(90)",
    fill: "#0072ce",
    stroke: "#0072ce",
    strokeWidth: 0.1
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaymentProcessing);
export default __webpack_public_path__ + "static/media/Payment_Processing.7f8e1015047082cbfd795d9d9516f952.svg";
export { ForwardRef as ReactComponent };